import React, { useState, useMemo , useRef} from "react";
import MainButton from "../button";
import { A_P_SELECTED_ITEM_TYPES, RESOURCES } from "../../utilities/constants";
import ComponentWrapper from "./SelectedItemTypes";
import MainInput from "../input";
import Card from "../card";
import MainImage from "../image";
import RadioButton from "../radioButton/SquareRadioButton";

import "./index.scss";
import { COMPONENT_SOURCE_TYPES } from "./constants";
import { getFirstAvailableNumber } from "../../utilities/helpers";

const SelectedItem = ({
  componentSourceOptions,
  item,
  selectedTemplate,
  fieldsData,
  selectedPorts,
  setSelectedPorts,
  setCustomTemplate,
  savedData,
  setSavedData,
  customTemplate,
  deleteRecourse,
  deletedData,
  ACUModel,
}) => {
  const selectedItemsRef = useRef({})
  const [selectedType, setSelectedType] = useState(null);
  const [defaultIndex, setDefaultIndex] = useState(1);
  const handelTemplateData = (key, value) => {
    setCustomTemplate((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };
  

  
  const [menu, setMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    selectedItem: null,
  });

  const returnEmptyPorts = (object) => {
    const key = object.input ? "input" : "output";

    let value = object[key];
    if (selectedItemsRef.current[key] &&  selectedItemsRef.current[key][object.component_source] && selectedItemsRef.current[key][object.component_source][value]) {
      value = ""
      // selectedItemsRef.current[key][object.component_source][value] = true;
    }
    return { [key]: value };
  };

  const tabList = useMemo(() => {
    selectedItemsRef.current = {...selectedPorts}
    const res =
      typeof selectedTemplate.data.resources === "string"
        ? JSON.parse(selectedTemplate.data.resources)
        : selectedTemplate.data.resources;
    setSelectedType(selectedTemplate.data.readers[0]);
    setCustomTemplate({
      name: selectedTemplate.label,
      value: selectedTemplate.value,
      save_as_template: false,
      templateName: `template_${selectedTemplate.label}`,
    });
    const defaultData = {};
    selectedTemplate.data.readers.map((item) => {
      const key =
        RESOURCES[item.type].label === "RFID"
          ? `${RESOURCES[item.type].label}${item.port}`
          : RESOURCES[item.type].label;

      if (!deletedData[key]) {
        defaultData[key] = {
          ...item,
          defaultPort: item.port,
          name: RESOURCES[item.type].label,
          templateName: "",
          component_source: COMPONENT_SOURCE_TYPES[item.component_source],
        };
      }
    });

    Object.keys(res).map((item) => {
      if (!deletedData[res[item].name]) {
        defaultData[item] = {
          ...res[item],
          component_source: COMPONENT_SOURCE_TYPES[res[item].component_source],
        };
      }
    });
    setSavedData(defaultData);
    const readers = selectedTemplate.data.readers.filter((elem) => {
      return !deletedData[`RFID${elem.port}`];
    });

    const resources = {};

    for (let item in res) {
      if (!deletedData[item]) {
        resources[item] = res[item];
      }
    }
    return { resources, readers };
  }, [selectedTemplate, deletedData]);

  const handleContextMenu = (event, item) => {
    event.preventDefault();
    const rect = event.currentTarget.getBoundingClientRect();

    setMenu({
      visible: true,
      x: rect.right - 25,
      y: rect.bottom - 15,
      selectedItem: item,
    });
  };

  const handleClickOutside = () => {
    setMenu({ ...menu, visible: false });
  };
  const detectTheme = () => {
    return JSON.parse(localStorage.getItem("theme_config"))
      ? JSON.parse(localStorage.getItem("theme_config")).theme
      : "light";
  };

  return (
    <div
      className={`selected-item-container ${detectTheme()}`}
      onClick={handleClickOutside}
    >
      <div className="card-item">
        <Card title={item.name} className={`wizard-item`}>
          <section className="wizard-item-img-container">
            <MainImage src={item.img} alt="Test img" />
          </section>
          <section className="wizard-item-info ">
            <MainInput
              label={"Name"}
              value={customTemplate.name}
              onChange={(value) => {
                handelTemplateData("name", value);
              }}
            />
            <MainInput
              label={"Description"}
              placeholder={"Description..."}
              value={customTemplate?.description}
              onChange={(value) => {
                handelTemplateData("description", value);
              }}
            />
          </section>
          <section className="wizard-item-template-info">
            <div>
              <RadioButton
                label="Save as Template"
                onChange={(value) => {
                  handelTemplateData("save_as_template", value);
                }}
                isSelected={customTemplate.save_as_template}
              />
            </div>
            <MainInput
              label={"Template name"}
              placeholder="Enter Template name "
              disabled={!customTemplate.save_as_template}
              value={customTemplate.templateName}
              onChange={(value) => {
                handelTemplateData("templateName", value);
              }}
            />
          </section>
        </Card>
      </div>
      <>
        <ul className={"item-list"}>
          <>
            {tabList.readers.map((element, index) => {
              return (
                <li
                  onContextMenu={(e) => {
                    if (selectedType?.port === element.port) {
                      handleContextMenu(e, element.type);
                    }
                  }}
                  className={`item ${
                    selectedType?.port === element.port ? "selected" : ""
                  }`}
                  key={`${RESOURCES[element.type].label}--${index}`}
                  onClick={() => {
                    setSelectedType(element);
                    setDefaultIndex(
                      RESOURCES[element.type].label === "RFID"
                        ? element.port
                        : ""
                    );
                  }}
                >
                  {RESOURCES[element.type].label}
                </li>
              );
            })}
          </>
          <>
            {Object.keys(tabList.resources).map((element, index) => {
              return (
                <li
                  onContextMenu={(e) => {
                    if (selectedType?.name === element) {
                      handleContextMenu(e, element.type);
                    }
                  }}
                  className={`item ${
                    selectedType?.name === element ? "selected" : ""
                  }`}
                  key={`${RESOURCES[element].label}--${index}`}
                  onClick={() => {
                    setSelectedType(tabList.resources[element]);
                  }}
                >
                  {RESOURCES[element].label}
                </li>
              );
            })}
          </>
        </ul>
        <div>
          {menu.visible && (
            <div
              className={"menu-continer"}
              style={{
                top: menu.y,
                left: menu.x,
              }}
            >
              <button
                className={"menu-delete-item"}
                onClick={() => {
                  deleteRecourse(selectedType);
                }}
              >
                Delete
              </button>
            </div>
          )}
        </div>
      </>
      <div className="selected-item-type">
        {selectedType && (
          <ComponentWrapper
            ACUModel={ACUModel}
            savedData={savedData}
            setSavedData={setSavedData}
            setSelectedPorts={setSelectedPorts}
            selectedPorts={selectedPorts}
            componentSourceOptions={componentSourceOptions}
            fieldsData={fieldsData}
            defaultPort={
              selectedType?.defaultName ? selectedType.defaultName : ""
            }
            name={
              selectedType.port
                ? RESOURCES[`${selectedType.type}`].value
                : RESOURCES[selectedType.name].value
            }
            selectedType={selectedType}
          />
        )}
      </div>
    </div>
  );
};

export default SelectedItem;
